<template>
  <div id="gatewayConfigurationGeolocation">
    <card :title="$t('gc-geolocation:fineTimestamKeys')" no-body no-footer no-padding>
      <table v-if="keys.length > 0" slot="card-table" class="table mb-0">
        <thead>
          <tr>
            <th>{{ this.$t('gc-geolocation:index') | capitalize }}</th>
            <th>{{ this.$t('gc-geolocation:key') | capitalize }}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="key in keys" :key="key.index">
            <td>{{ key.index }}</td>
            <td>{{ key.aesKey }}</td>
            <td class="text-right"><i :title="$t('gc-geolocation:remove') | capitalize" class="icon-trash" @click="confirmDeleteCluster(key)" /></td>
          </tr>
        </tbody>
      </table>
      <div v-if="keys && keys.length===0" slot="card-table" class="text-center font-italic text-muted p-3">{{ $t('gc-geolocation:noData') | capitalize }}</div>
    </card>

    <confirm id="deleteFineTimestampKey"
             v-model="showDeleteKeyConfirm"
             :message="$t('gc-geolocation:deleteFineTimestampKey')"
             @confirm:validate="deleteKey"
    />

    <floating-button :click-handler="() => { showAddKeyForm=true }" icon-classes="icon-add" />
    <geolocation-form v-model="showAddKeyForm" @success="getKeys" />
  </div>
</template>

<script>
import { isNil, sortBy } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'

import GeolocationForm from './GeolocationForm'

export default {
  titleKey: 'gatewayConfGeolocation',

  components: { GeolocationForm },

  props: {
    eui: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      // Add key
      showAddKeyForm: false,
      // Delete key
      showDeleteKeyConfirm: false,
      keyToDelete: null,
      // List keys
      keys: {}
    }
  },

  computed: {
    ...mapGetters(['gateway'])
  },

  watch: {
    eui () {
      // Reset data, and get data from new gateway
      this.keys = []
    },

    gateway () {
      // Do not refresh is we olready have the data
      if (!isNil(this.keys)) return

      this.getKeys()
    }
  },

  created () {
    this.getKeys()
  },

  methods: {
    async getKeys () {
      // Keys are stored in gatewayDto
      await this.$store.dispatch('getGateway', this.eui)
      this.keys = sortBy(this.gateway.gatewayKeys, ['index']) || []
    },

    confirmDeleteCluster (key) {
      this.showDeleteKeyConfirm = true
      this.keyToDelete = key
    },

    async deleteKey () {
      let error
      [error] = await to(this.$api.deleteLnsGatewayAesKey(this.gateway, this.keyToDelete.index))
      if (error) return

      this.getKeys()
    }
  }
}
</script>
